module.exports = __webpack_public_path__ + "img/web4icon3.79b0bed0.png";